import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ContentProvider } from "@/context/ContentContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { Toaster } from "sonner";

import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";
import BusinessPage, { BusinessCollectionPage } from "@/pages/BusinessPage";
import BusinessReorderPage from "@/pages/BusinessReorderPage";
import ArtDetailPage from "@/pages/ArtDetailPage";
import CustomRequestPage from "@/pages/CustomRequestPage";
import ContactPage from "@/pages/ContactPage";
import ReviewsPage from "@/pages/ReviewsPage";
import CartPage from "@/pages/CartPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

const ProtectedAdmin = ({ children }) => {
  const { admin, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-neutral-500">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <CurrencyProvider>
            <CartProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/gallery" element={<GalleryPage />} />
                  <Route path="/business" element={<BusinessPage />} />
                  <Route path="/business/reorder/:token" element={<BusinessReorderPage />} />
                  <Route path="/business/:id" element={<BusinessCollectionPage />} />
                  <Route path="/art/:id" element={<ArtDetailPage />} />
                  <Route path="/artwork/:id" element={<ArtDetailPage />} />
                  <Route path="/custom" element={<CustomRequestPage />} />
                  <Route path="/custom-request" element={<CustomRequestPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/reviews" element={<ReviewsPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                  <Route path="/admin/login" element={<AdminLoginPage />} />
                  <Route path="/admin" element={<ProtectedAdmin><AdminDashboardPage /></ProtectedAdmin>} />
                </Routes>
              </BrowserRouter>
              <Toaster position="top-center" richColors />
            </CartProvider>
          </CurrencyProvider>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
